import React, { useEffect, useState } from 'react';
import { useDashboardContext } from '../../../components/providers/DashboardProvider';
import { Box } from '@mui/material';
import ClusterPicker from './ClusterPicker';
import { useNavigate } from 'react-router-dom';

const LocationPage = () => {

  const navigate = useNavigate();
  const { fetchAvailableClusters, clustersList, clustersFetchCount } = useDashboardContext();
  const { selectedCluster, selectClusterById } = useDashboardContext();

  const [fetchingClusters, setFetchingClusters] = useState(true);

  const updateClusterList = async () => {
    setFetchingClusters(true);
    await fetchAvailableClusters();
    setFetchingClusters(false);
  }

  const handleSelect = async (cluster) => {
    const res = await selectClusterById(cluster.cluster_id);
    if (res) {
      goToOverview();
    } else {
      console.log("Something is wrong");
    }
  }

  const goToOverview = () => {
    navigate("/dashboard/overview");
  }

  useEffect(() => {
    updateClusterList();
  }, []);

  useEffect(() => {
    const initlize = async () => {
      if (clustersList.length === 1 && clustersFetchCount === 1) {
        const res = await selectClusterById(clustersList[0].cluster_id);
        if (res) {
          goToOverview();
        } else {
          console.log("Something is wrong");
        }
      }
    }
    initlize();
  }, [clustersList, clustersFetchCount]);


  return (
    <Box sx={{
      display: "flex",
      flexDirection: "column",
      padding: 3,
      backgroundColor: "var(--c-surface)",
      borderRadius: "16px",
      border: "1px solid var(--c-border)",
    }}>
      <ClusterPicker
        data={clustersList}
        loading={fetchingClusters}
        selectedCluster={selectedCluster}
        onSelect={handleSelect}
        onRefresh={updateClusterList}
      />
    </Box>
  )
}

export default LocationPage;
